import { render, staticRenderFns } from "./CouponsTable.vue?vue&type=template&id=549b6924"
import script from "./CouponsTable.vue?vue&type=script&lang=js"
export * from "./CouponsTable.vue?vue&type=script&lang=js"
import style0 from "./CouponsTable.vue?vue&type=style&index=0&id=549b6924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports